import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import Translate from '../../src/components/Translate/Translate';
import ErrorPageLayout from '../../src/components/_layouts/ErrorPageLayout/ErrorPageLayout';

export default class Error404 extends AbstractView {
    static layout = ErrorPageLayout;
    protected static pageTitle = 'Errors.page_not_found';

    protected renderContent(): React.ReactNode {
        return <Translate message="Errors.page_not_found"/>;
    }
}
